<ui-icon-button [title]="'View PDF'" *ngIf="data && (data.pdfName)" [iconName]="'icon-pdf'" [heightInPx]="'27'" [widthInPx]="'20'" (click)="viewPdf()"></ui-icon-button>

<ui-icon-button [title]="'Delete'" [disabled]="false" [color]="'BLUE' | iconButtonColorEnumPipe" [iconName]="'icon-circle-trash-can'" [heightInPx]="'25px'" [widthInPx]="'25px'" [screenReaderText]="'Delete'" (click)="delete()"></ui-icon-button>


<ui-icon-button [title]="'Move'" [disabled]="false" [color]="'Green' | iconButtonColorEnumPipe" [iconName]="'icon-send-email'" [heightInPx]="'25px'" [widthInPx]="'25px'" [screenReaderText]="'Move'" (click)="move()"></ui-icon-button>

